import {cache0} from "../../utils/cache0";

//https://xpresso.awsdev.xpressdocs.com

export const isDevQuan = cache0(()=> (
    !!localStorage.DEV_QUAN
));
